import {useCallback, useEffect} from "react";

export const useSchedulerCalendarEffects = ({
                                                calendarRef,
                                                scrollTargetRef,
                                                horizontalScrollTargetRef,
                                                dragActiveRef,
                                                selectedMenu,
                                                setSelectedMenu,
                                                menuOptions, scrollArea}) => {

    const findScrollTargets = useCallback(() => {
        let verticalTarget = document.scrollingElement || document.documentElement;
        let horizontalTarget = null;

        const calendarApi = calendarRef.current?.getApi?.();
        const calendarEl = calendarApi?.el || calendarRef.current?.el;

        if (calendarEl) {
            let el = calendarEl.parentElement;

            while (el) {
                const style = window.getComputedStyle(el);
                const overflowY = style.overflowY;
                const overflowX = style.overflowX;

                const canScrollY =
                    (overflowY === 'auto' || overflowY === 'scroll') &&
                    el.scrollHeight > el.clientHeight + 1;

                const canScrollX =
                    (overflowX === 'auto' || overflowX === 'scroll') &&
                    el.scrollWidth > el.clientWidth + 1;

                if (canScrollY) verticalTarget = el;
                if (canScrollX && !horizontalTarget) horizontalTarget = el;

                if (canScrollY && canScrollX) break;
                el = el.parentElement;
            }

            if (!horizontalTarget) {
                horizontalTarget =
                    calendarEl.querySelector('.fc-scroller') ||
                    calendarEl.querySelector('.fc-timegrid-body') ||
                    calendarEl.querySelector('.fc-timeGrid-body');
            }
        }

        return {verticalTarget, horizontalTarget: horizontalTarget || verticalTarget};
    }, []);

    const isPointerDown = (e) => {
        if (e.buttons != null) return e.buttons === 1;
        return !!e.touches?.length;
    };

    useEffect(() => {
        if (!selectedMenu && menuOptions.length) setSelectedMenu(menuOptions[0]);
    }, [menuOptions, selectedMenu]);

    useEffect(() => {
        const {verticalTarget, horizontalTarget} = findScrollTargets();
        scrollTargetRef.current = verticalTarget;
        horizontalScrollTargetRef.current = horizontalTarget;
    }, [findScrollTargets]);


    useEffect(() => {
        const SCROLL_STEP = 3;

        const handleMove = (e) => {
            if (!isPointerDown(e)) return;
            if (!dragActiveRef.current) return;

            let clientX = null;
            let clientY = null;

            if ('clientX' in e && 'clientY' in e) {
                clientX = e.clientX;
                clientY = e.clientY;
            } else if (e.touches && e.touches.length) {
                clientX = e.touches[0].clientX;
                clientY = e.touches[0].clientY;
            }

            // ---------- VERTICAL SCROLL ----------
            if (clientY != null) {
                const viewportHeight = window.innerHeight;
                const topThreshold = scrollArea;
                const bottomThreshold = viewportHeight - scrollArea;

                const verticalTarget =
                    scrollTargetRef.current || document.scrollingElement || document.documentElement;

                if (clientY < topThreshold) verticalTarget.scrollTop -= SCROLL_STEP;
                else if (clientY > bottomThreshold) verticalTarget.scrollTop += SCROLL_STEP;
            }

            const horizontalTarget = horizontalScrollTargetRef.current;
            if (horizontalTarget && clientX != null) {
                const rect = horizontalTarget.getBoundingClientRect();
                const leftThreshold = rect.left + scrollArea;
                const rightThreshold = rect.right - scrollArea;

                const insideVertically = clientY == null || (clientY >= rect.top && clientY <= rect.bottom);

                if (insideVertically) {
                    if (clientX < leftThreshold) horizontalTarget.scrollLeft -= SCROLL_STEP;
                    else if (clientX > rightThreshold) horizontalTarget.scrollLeft += SCROLL_STEP;
                }
            }
        };

        window.addEventListener('pointermove', handleMove, {passive: false});
        window.addEventListener('touchmove', handleMove, {passive: false});
        window.addEventListener('mousemove', handleMove);

        return () => {
            window.removeEventListener('pointermove', handleMove);
            window.removeEventListener('touchmove', handleMove);
            window.removeEventListener('mousemove', handleMove);
        };
    }, []);


    return null;
}